import React from 'react';
import { HelpTooltip } from '../help/help-tooltip';

const BoundTextarea = React.memo(
  ({
    formId,
    id,
    className,
    placeholder,
    rows,
    label,
    format,
    value,
    required,
    disabled,
    autoFocus,
    type,
    autoComplete,
    spellCheck,
    onChange,
    onKeyPress,
    noLabel,
    helpText,
  }) => {
    return (
      <div className={`bound-input ${className || ''}`}>
        <div className="control-label">
          {!!label && <div className={'label'}>{label} </div>}

          {!!helpText && (
            <div className="control-help">
              <HelpTooltip text={helpText} />
            </div>
          )}
        </div>
        <textarea
          id={id}
          className={className}
          rows={rows || 4}
          placeholder={placeholder}
          value={value}
          required={required}
          disabled={disabled}
          autoFocus={autoFocus}
          spellCheck={spellCheck}
          autoComplete={autoComplete || 'off'}
          onChange={onChange}
        />
      </div>
    );
  },
);

export default BoundTextarea;
